import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "24",
  viewBox: "0 0 23 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"11.5\" cy=\"12\" r=\"11.5\" fill=\"#007AFF\" fill-opacity=\"0.15\"></circle><rect x=\"7.26562\" y=\"8.30273\" width=\"3.69883\" height=\"5.91813\" fill=\"#007AFF\"></rect><line x1=\"9.11988\" y1=\"5.3418\" x2=\"9.11988\" y2=\"17.1781\" stroke=\"#007AFF\" stroke-width=\"0.739766\"></line><rect x=\"11.7031\" y=\"9.7793\" width=\"3.69883\" height=\"5.91813\" fill=\"#007AFF\"></rect><line x1=\"13.5574\" y1=\"6.81836\" x2=\"13.5574\" y2=\"18.6546\" stroke=\"#007AFF\" stroke-width=\"0.739766\"></line>", 5)
  ])))
}
export default { render: render }